import { render, staticRenderFns } from "./HabitatAttributes.vue?vue&type=template&id=8c9ceb6e&scoped=true&"
import script from "./HabitatAttributes.vue?vue&type=script&lang=js&"
export * from "./HabitatAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9ceb6e",
  null
  
)

export default component.exports